import { css, Global } from "@emotion/react";
import { PropsWithChildren } from "react";

const DashboardTemplate: React.FC<PropsWithChildren<unknown>> = ({
  children,
}): JSX.Element => {
  return (
    <>
      <Global
        styles={css`
          body {
            background-color: var(--chakra-colors-gray-200);
          }
        `}
      />
      <div>{children}</div>
    </>
  );
};

export default DashboardTemplate;
